import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Admin');
  const { login } = useApp();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple authentication (for demo purposes)
    // In production, this would connect to a backend
    const userData = {
      id: Date.now().toString(),
      username,
      role,
      email: `${username}@ecourt.com`,
    };

    login(userData);
    navigate('/app/dashboard');
  };

  return (
    <div className="login-container">
      <div className="login-nav">
        <Link to="/" className="login-nav-link">← Back to Home</Link>
      </div>
      <div className="login-card">
        <div className="login-header">
          <h1>⚖️ e-Court Management System</h1>
          <p>Please login to continue</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Enter username"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter password"
            />
          </div>

          <div className="form-group">
            <label>Role</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="Admin">Admin</option>
              <option value="Judge">Judge</option>
              <option value="Clerk">Clerk</option>
              <option value="Advocate">Advocate</option>
              <option value="Public">Public User</option>
            </select>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        <div className="login-info">
          <p><strong>Demo Login:</strong> Enter any username and password</p>
          <p>Select your role to access role-specific features</p>
        </div>

        <div className="login-links">
          <Link to="/case-status">Check Case Status</Link>
          <span>|</span>
          <Link to="/courts">View Courts</Link>
          <span>|</span>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;

